interface CompletionHeaderProps {
  getCompletionMessage: () => string;
  isPracticeMode?: boolean;
}

export const CompletionHeader = ({ getCompletionMessage, isPracticeMode = false }: CompletionHeaderProps) => {
  const messageColor = isPracticeMode ? 'text-[#9b87f5]' : 'text-[#de0046]';
  
  return (
    <>
      <div className="flex flex-col items-center justify-center mb-2 mt-0">
        <div className={`text-sm font-medium ${isPracticeMode ? 'text-[#9b87f5]' : 'text-[#de0046]'}`}>
          {isPracticeMode ? 'Practice Mode' : 'Daily Challenge'}
        </div>
      </div>
      <h2 className={`text-2xl font-bold text-center ${messageColor} mb-4`}>
        {getCompletionMessage()}
      </h2>
    </>
  );
};
